import { Platform } from "react-native";

export const supportsNativeDriver = Platform.OS !== "web";
